/* eslint-disable react/destructuring-assignment */
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import Logo from "../Logo";

type State = {
  hasError: boolean;
};

type Props = {
  children: React.ReactNode;
};

export default class ChunkErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Only show refresh for chunk load errors
    if (
      error.name === "ChunkLoadError" ||
      error.message.includes("Failed to fetch dynamically imported module")
    ) {
      console.error("ChunkErrorBoundary (ChunkLoadError)", error);
      return { hasError: true };
    }
    // pass other errors to the parent error boundary
    if (error) {
      console.error("ChunkErrorBoundary (other errors)", error);
      throw error;
    }
    return { hasError: false };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            alignItems: "center",
            backgroundColor: "background.paper",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            gap: 2,
            justifyContent: "center",
            left: 0,
            p: 3,
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 2000,
          }}
        >
          <Logo />
          <Typography variant="h6" color="primary.main">
            New version of Medial Health is available. Please refresh the page.
          </Typography>
          <Button
            onClick={() => window.location.reload()}
            variant="contained"
            color="primary"
          >
            Refresh page
          </Button>
        </Box>
      );
    }

    return this.props.children || <Box />;
  }
}
